// Fiók-kategória jelölés (A++/A+/A/B/C) — a régi CRM `AccountCategoryEnum` pasztell „minőség"-skálájának
// utódja (rose → pink → orange → amber gradiens). SZÁNDÉKOSAN NEM a szemantikus `Badge`-re épül: kompakt,
// monogram-szerű, fix minimum-szélességű pill (ring-inset + félkövér) → vizuálisan ELKÜLÖNÜL a típustól
// (semleges `Badge`) és a státusztól (szemantikus szín + ikon). Ismeretlen/üres érték → null (nem renderel).
//
// SZÍN: a kategória egy DOMÉN-skála (nem szemantikus státusz), amelyre nincs dedikált design-token — ezért
// a Tailwind alap-palettát használjuk EXPLICIT light+dark osztály-párokkal (indokolt `dark:` — a token-alapú
// auto-adaptáció itt nem alkalmazható). A teljes osztály-stringek literálként állnak → a JIT begyűjti őket.
import { cn } from '@/lib/utils';

const CATEGORY_STYLES: Record<string, string> = {
  'A++':
    'bg-rose-100 text-rose-700 ring-rose-200 dark:bg-rose-500/20 dark:text-rose-200 dark:ring-rose-400/30',
  'A+': 'bg-rose-50 text-rose-600 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:ring-rose-400/20',
  A: 'bg-pink-100 text-pink-700 ring-pink-200 dark:bg-pink-500/15 dark:text-pink-300 dark:ring-pink-400/25',
  B: 'bg-orange-100 text-orange-700 ring-orange-200 dark:bg-orange-500/15 dark:text-orange-300 dark:ring-orange-400/25',
  C: 'bg-amber-100 text-amber-700 ring-amber-200 dark:bg-amber-500/15 dark:text-amber-300 dark:ring-amber-400/25',
};

export interface AccountCategoryBadgeProps {
  /** A nyers kategória-érték (A++/A+/A/B/C). Ismeretlen → nem renderel. */
  category: string;
  className?: string;
}

export function AccountCategoryBadge({
  category,
  className,
}: AccountCategoryBadgeProps): JSX.Element | null {
  const style = CATEGORY_STYLES[category];
  if (!style) return null;
  return (
    <span
      className={cn(
        'text-2xs inline-flex h-5 min-w-[1.75rem] shrink-0 items-center justify-center rounded-full px-1.5 font-semibold leading-none ring-1 ring-inset',
        style,
        className,
      )}
      title={category}
    >
      {category}
    </span>
  );
}
